import Keycloak from 'keycloak-js';

const keycloakMiddleware = store =>
{
    const keycloak = Keycloak("keycloak.json")
    const initCallback = (authenticated) =>
    {
        store.dispatch({type:"USER:AUTHENTICATED", authenticated: authenticated, engine: keycloak});
        if (authenticated)
        {
            store.dispatch({type:"USER:LOAD"});
        }
    }
    const profileCallback = (profile) =>
    {
        store.dispatch({type: "USER:PROFILE", profile : profile});
    }
    const errorCallback = (error) =>
    {
        store.dispatch({type:"EXCEPTION:USER:ERROR", message: error});
        console.log(error);
    }
    return next => action =>
    {
        switch(action.type)
        {
            case "USER:INIT":
                keycloak.init({checkLoginIframe: true}).success(initCallback).error(errorCallback);
                break;
            case "USER:LOGIN":
                keycloak.login();
                break;
            case "USER:LOGOUT":
                keycloak.logout({redirectUri:  window.location.protocol + "//" + window.location.host + "/login"});
                break;
            case "USER:ACCOUNT":
                keycloak.accountManagement();
                break;
            case "USER:LOAD":
                keycloak.loadUserProfile().success(profileCallback).error(errorCallback);
            default:
                break;
        }
        next(action);
    }
}

export {keycloakMiddleware as keycloak};